




























import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { useAttributes } from '~/composables';
import { SfHeading, SfLink } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import SvgImage from '~/components/General/SvgImage.vue';
import {
  getName as getProductName,
  getProductSku,
  getProductCollection,
  getProductMadeInCanada,
} from '~/modules/catalog/product/getters/productGetters';

export default defineComponent({
  components: {
    SfHeading,
    SfLink,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const { getAttributeLabel } = useAttributes();

    const productCollection = computed(() => getAttributeLabel('b_collection_name', getProductCollection(props.product)));
    const productCollectionLink = computed(() => `/collections/${productCollection.value.split(' ')[0].charAt(0).toLowerCase() + productCollection.value.split(' ')[0].slice(1)}`);

    return {
      getAttributeLabel,
      getProductName,
      getProductSku,
      getProductCollection,
      productCollection,
      productCollectionLink,
      getProductMadeInCanada,
    };
  },
});
